import {
  useInvalidateMobileOffers,
  useInvalidateConsolidatedOffers,
  useInvalidateSegmentedOffers,
  useInvalidateUserStocks,
} from '@wwe-portal/web/providers/queries/offer';
import {
  useInvalidateLeaderboard,
  useInvalidateUserProgress,
} from '@wwe-portal/web/providers/queries/rbe';
import { useInvalidateStampCard } from '@wwe-portal/web/providers/queries/stamp-card';
import { useInvalidateCurrentUser } from '@wwe-portal/web/providers/queries/user-info';

export const useInvalidateOffer = () => {
  const invalidateUserInfo = useInvalidateCurrentUser();
  const invalidateLeaderboard = useInvalidateLeaderboard();
  const invalidateStampcard = useInvalidateStampCard();
  const invalidateStock = useInvalidateUserStocks();
  const invalidateConsolidatedOffers = useInvalidateConsolidatedOffers();
  const invalidateSegmentedOffers = useInvalidateSegmentedOffers();
  const invalidateOffers = useInvalidateMobileOffers();
  const invalidateUserProgress = useInvalidateUserProgress();

  return async () => {
    await Promise.all([
      invalidateUserInfo(),
      invalidateUserProgress(),
      invalidateLeaderboard(),
      invalidateStampcard(),
      invalidateStock(),
      invalidateConsolidatedOffers(),
      invalidateSegmentedOffers(),
      invalidateOffers(),
    ]);
  };
};
